// src/Components/Forms/Financement/Salam/Reception/Tab1.tsx
import React from 'react';
import { Box, Grid } from '@mui/material';
import InputForm from '../../../../InputT';
import SearchModal from '../../../../SearchModal';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';

const Tab1 = (props: { form?: any }) => {
  const searchLieuLivraison: ParamsPicklist = {
    CodeAgence: '',
    Table: "PointStockage",
    Colonne1: "CodePoint",
    Colonne2: "Libelle",
    Colagence: '101',
    Choix: 22
  };

  let searchDemande: ParamsPicklist = {
    CodeAgence: '',
    Table: "DEMAND_FINSALAM",
    Colonne1: "NumeroDemande",
    Colonne2: "NOMCLI",
    Colagence: '101',
    Choix: 22
  };

  let searchFinancement: ParamsPicklist ={
    CodeAgence: '',
    Table: "FinSalam",
    Colonne1: "NumeroFinancement",
    Colonne2: "CodeSalam",
    Colagence: '101',
    Choix: 22
  }

  let searchSalam: ParamsPicklist = {
    CodeAgence: '',
    Table: "ParamsSalam",
    Colonne1: "CodeSalam",
    Colonne2: "LibelleSalam",
    Colagence: '101',
    Choix: 22
  };

  let searchClient: ParamsPicklist = {
    CodeAgence: '',
    Table: "CLIENT",
    Colonne1: "NUMCLI",
    Colonne2: "NOMCLI",
    Colagence: '101',
    Choix: 22
  };

  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width={'85%'} position={'absolute'}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <SearchModal width={5} label="N° Demande" name="NumeroDemande" disabled Parametre={searchDemande}  Titre='Rechercher Demande'/>
          </Grid>
          <Grid item xs={12} md={6}>
            <SearchModal width={7} label="N° Financement" name="NumeroFinancement" disabled Parametre={searchFinancement} Titre='Recherhcer Financement'/>
          </Grid>
          <Grid item xs={12} md={6}>
            <SearchModal width={5} label="Type Salam" name="CodeSalam" disabled Titre='Rechercher Type Salam' Parametre={searchSalam} />
          </Grid>
          <Grid item xs={12} md={6}>
            <SearchModal width={5} label="Client" name="NOMCLI" disabled Parametre={searchClient} Titre='Rechercher Client' />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputForm width={5} label="Quantité commandée" name="Quantite" disabled type="number" money />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputForm width={5} label="Unité" name="Unite" disabled type="text" />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputForm width={7} label="Date livraison prévue" name="DateLivraison" disabled type="date" />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputForm width={5} label="Reste à livrer" name="ResteALivrer" disabled type="number" money />
          </Grid>
          <Grid item xs={12} md={6}>
            <SearchModal 
              Titre="Recherche Lieu de livraison" 
              width={5} 
              label="Lieu de livraison" 
              name="LieuLivraison" 
              form={props.form}
              disabled={false}
              Parametre={searchLieuLivraison} 
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputForm width={7} label="Date réception réelle" name="DateReceptionReelle" type="date" />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputForm width={7} label="Quantité reçue" name="QuantiteRecue" type="number" money />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputForm width={7} label="N° Bordereau" name="ReferenceBordereau" type="text" />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputForm width={7} label="Commentaire réception" name="CommentaireReception" type="TextArea" />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Tab1;